import { render } from "./UserFollows.vue?vue&type=template&id=bf3d6a7e"
import script from "./UserFollows.vue?vue&type=script&lang=js"
export * from "./UserFollows.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__